export default {
      id: "merge-individual-usage",
      viewBox: "0 0 50 36",
      url: "/dist/svg/" + "sprite.svg#merge-individual-usage",
      toString: function () {
        return this.url;
      }
    }